import React from 'react';
import classNames from 'classnames/bind';

import Pipeline from 'types/pipeline';

import { Radio, RadioOption, RadioValue } from 'components/Radio/Radio';

import { PipelinesList } from './PipelinesList';
import { PipelineTemplatesList } from './PipelineTemplatesList';
import styles from './PipelinePicker.module.scss';

const c = classNames.bind(styles);

export type PipelinePickerWithTemplatesProps = {
  hasPipelines: boolean;
  onPipelineSelect: (pipeline: Pipeline) => void;
};

export function PipelinePickerWithTemplates({
  hasPipelines,
  onPipelineSelect,
}: PipelinePickerWithTemplatesProps) {
  const [activeView, setActiveView] = React.useState<RadioValue>(
    hasPipelines ? 'pipelines' : 'templates'
  );

  return (
    <>
      <div className={c('view-switch-controls')}>
        <Radio
          id="rapid-deploy-video-source-type"
          value={activeView}
          onChange={setActiveView}
        >
          <RadioOption value="pipelines" icon="camera">
            Your workflows
          </RadioOption>
          <RadioOption value="templates" icon="stream">
            Workflow templates
          </RadioOption>
        </Radio>
      </div>

      {activeView === 'pipelines' ? (
        <PipelinesList onSelect={onPipelineSelect} />
      ) : (
        <PipelineTemplatesList onSelect={onPipelineSelect} />
      )}
    </>
  );
}
